import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AssortmentService, AuthService, Assortment, AssortmentRecursive } from 'gung-standard';
import { Observable } from 'rxjs';
import { filter, switchMap, map, tap } from 'rxjs';

@Component({
  selector: 'tylo-tylo-home-assortment',
  templateUrl: './tylo-home-assortment.component.html',
  styleUrls: ['./tylo-home-assortment.component.css']
})
export class TyloHomeAssortmentComponent implements OnInit {
  rootAssortment: Assortment;

  constructor(
    private assortmentService: AssortmentService,
    private authService: AuthService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    const currentLang = this.translateService.currentLang;
    return this.authService
      .getCurrentUser()
      .pipe(
        filter(user => !!user),
        switchMap(user => {
          return this.assortmentService.getAssortment(user.assortment);
        })
      )
      .subscribe((assortments: AssortmentRecursive) => {
        this.rootAssortment = assortments;
        if (this.rootAssortment.children) {
          this.rootAssortment.children = this.rootAssortment.children.map((assortment: AssortmentRecursive) => {
            if (
              assortment.extra.i18 &&
              assortment.extra.i18[currentLang] &&
              assortment.extra.i18[currentLang].assortmentName
            ) {
              assortment.name = assortment.extra.i18[currentLang].assortmentName;
            }
            return assortment;
          });
        }
      });
  }

  getAssortments(): Observable<Assortment[]> {
    return this.authService.getCurrentUser().pipe(
      filter(user => !!user),
      switchMap(user => {
        return this.assortmentService.getAssortment(user.assortment);
      }),
      map(assortment => assortment.children)
    );
  }

  getStyle(assortment: Assortment, size?: string): any {
    return {
      'background-image': this.getAssortmentImage(assortment, size)
    };
  }

  getAssortmentImage(assortment: Assortment, size?: string): string {
    const assortmentVar = assortment as any;
    const fitInSize = size || '500x400';
    if (assortmentVar.extra.images && assortmentVar.extra.images.length > 0) {
      return `url('https://cdn1.gung.io/fit-in/${fitInSize}/filters:etag(${assortmentVar.extra.images[0].s3ETag}):quality(100)/${assortmentVar.extra.images[0].s3Uri}')`;
    } else {
      return `url('https://cdn1.gung.io/fit-in/${fitInSize}/filters:quality(100)/images/no-image.jpg')`;
    }
  }
}
